import clsx from 'clsx';
import styles from './PlaceInfo.module.scss';
import { useEffect, useRef, useState } from 'react';
import placeApi from '~/api/placeApi';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import { actions, useStore } from '~/store';
import { deletePlace, updatePlace } from '~/store/actions';

function PlaceInfo({ id, name }) {
    const [tripId] = useState(localStorage.getItem('tripId'));
    const [state, dispatch] = useStore();
    const [mode, setMode] = useState('showing');
    const [newName, setNewName] = useState(name);
    const refName = useRef();

    const handleOnclickEdit = () => {
        setMode('editing');
    };

    const handleOnclickCancel = () => {
        setMode('showing');
    };

    const handleOnclickDelete = () => {
        // check có đang sử dụng trong money nào ko?
        const kq = state.moneys.find((m) => m.placeId === id);
        if (kq) {
            toast.warn('Địa điểm này đang sử dụng rồi');
            return;
        }
        dispatch(deletePlace({ id }));
        setMode('showing');
        dispatch(actions.setLoading2({ loading2: true }));
        placeApi
            .delete({ id, tripId })
            .then((res) => {
                // console.log(res);
                if (isSuccess(res)) {
                    toast.success('Xóa thành công');
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading2({ loading2: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading2({ loading2: false }));
            });
    };

    const handleOnclickSave = () => {
        if (newName === name) {
            setMode('showing');
            return;
        }
        // check trùng tên với địa điểm khác
        const duplicatedName = state.places.find(
            (place) => place.name === newName,
        );
        if (duplicatedName) {
            toast.warn('Trùng tên với địa điểm khác rồi');
            return;
        }

        dispatch(updatePlace({ id, name: newName }));

        setMode('showing');
        dispatch(actions.setLoading2({ loading2: true }));
        placeApi
            .update({ id, name: newName, tripId })
            .then((res) => {
                // console.log(res);
                if (isSuccess(res)) {
                    toast.success('Sửa thành công');
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading2({ loading2: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading2({ loading2: false }));
            });
    };

    const handleOnChangeName = (e) => {
        setNewName(e.target.value);
    };

    useEffect(() => {
        if (mode === 'editing') {
            if (refName && refName.current) {
                refName.current.focus();
            }
        }
    }, [mode]);

    return (
        <div className={styles.wrapper}>
            {mode === 'showing' && (
                <div className={styles.showing}>
                    <div className={styles.name}>{name}</div>
                    <div className={styles.action}>
                        <button
                            className={clsx(styles.btn, styles.delete)}
                            onClick={handleOnclickDelete}
                        >
                            <i className="fa-solid fa-trash-can"></i>
                        </button>
                        <button
                            className={clsx(styles.btn, styles.edit)}
                            onClick={handleOnclickEdit}
                        >
                            <i className="fa-solid fa-pen"></i>
                        </button>
                    </div>
                </div>
            )}
            {mode === 'editing' && (
                <div className={styles.editing}>
                    <input
                        ref={refName}
                        className={styles.name}
                        type="text"
                        value={newName}
                        onChange={handleOnChangeName}
                    />
                    <div className={styles.action}>
                        <button
                            className={clsx(styles.btn, styles.cancel)}
                            onClick={handleOnclickCancel}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <button
                            className={clsx(styles.btn, styles.save)}
                            onClick={handleOnclickSave}
                        >
                            <i className="fa-solid fa-check"></i>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PlaceInfo;
